export default __webpack_public_path__ + "static/media/branding-bolditalic-webfont.3ca6d080.woff2";